const navbar = document.querySelector('#menu-navbar')

handleNavbar()
function handleNavbar() {
    handleNavbarScroll()
    window.addEventListener('scroll', handleNavbarScroll)
    function handleNavbarScroll() {
        const isScrolled = window.scrollY > 20
        navbar.classList[isScrolled ? 'add' : 'remove']('scrolled')
    }
}
